const state = {
  location: {
    lat: null,
    lon: null
  },
  error: {
    code: null,
    message: ''
  },
  id: null
}

export const getters = {
  location: state => {
    if (state.error.code) {
      return null
    }
    return { latitude: state.location.lat, longitude: state.location.lon }
  }
}

export const mutations = {
  setLocation(state, {lat, lon}) {
    state.location.lat = lat
    state.location.lon = lon
  },

  setError(state, error) {
    state.error.code = error.code
    state.error.message = error.message
  },

  setId(state, watchID) {
    state.watchID = watchID
  }
}

export const actions = {
  watch ({ state, commit }) {
    if (state.id) {
      helpers.error({code: null, message: 'Watch position is already running, unable to start it again'})
    }
    if (navigator && 'geolocation' in navigator) {
      commit('setId', navigator.geolocation.watchPosition(helpers.success, helpers.error))
    } else {
      helpers.error({code: null, message: 'Geolocation API is not present in this browser'})
    }
  },

  clear ({ state, commit }) {
    if (state.id) {
      navigator.geolocation.clearWatch(state.id)
      commit('setId', null)
    }
  },

  getCurrentLocation () {
    return navigator.geolocation.getCurrentPosition(helpers.success, helpers.error)
  }
}

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
}

// For internal use
export const helpers = {
  success({coords: {latitude, longitude}}) {
    Vue.$store.commit('geolocation/setLocation', {lat: latitude, lon: longitude})
    Vue.$store.commit('geolocation/setError', {code: null, message: ''})
  },

  error (error) {
    Vue.$store.commit('geolocation/setError', error)
  }
}

export const api = {}
